// Gate that useStreamingText awaits before opening the EventSource.
// Survives component remounts (e.g. when navigateOnBranchChange
// navigates to a fork, remounting Chat with a new key).
let serverGate: Promise<void> = Promise.resolve();

// Mutations that always insert a new chat object. patchMutate in
// ZeroSetup auto-gates these so useStreamingText waits for the
// server to confirm before opening the EventSource.
export const CHAT_CREATING_MUTATIONS = new Set([
  "createWorkflow",
  "createBranch",
]);

export function gatedMutate<T extends { server: Promise<unknown> }>(
  result: T
): T {
  let resolve: () => void;
  serverGate = new Promise<void>((r) => (resolve = r));
  void result.server.then(() => resolve());
  return result;
}

export function getServerGate() {
  return serverGate;
}
